import React, { useState, useEffect } from "react";
import { ThreeDMarqueeDemoSecond } from "../../components/CollegePage/HeroSection";
import WhyUsSection from "../../components/CollegePage/WhyUsCollege";
import { ServiceSection } from "@/components/CollegePage/ServiceSection";
import { LayoutGridDemo } from "../../components/CollegePage/Gallery";
import CollegeFinal from "@/components/CollegePage/CollegeFinal";

const CollegePage = () => {
  return (
    <div className="min-h-screen bg-black text-white font-inter px-0 md:px-0">
      <ThreeDMarqueeDemoSecond />
      <WhyUsSection />
      <ServiceSection />
      <LayoutGridDemo />
      <CollegeFinal />
    </div>
  );
};

export default CollegePage;
